// @ts-check
// =============================================================================
// js/screens/help.js - the Guide: the How-To-Play reference sheet.
//
// WHAT THIS IS (main-menu.md "Guide"; content plan in plan/help.md)
//   The minimal in-client rulebook (authored in data/guide-content.js,
//   shared with the duel's Help popup): a quick reference
//   (keywords, the Stunned status, actions, controls) and a seven-line Rules
//   list. Replaces the three legacy tutorial PNGs. Rules facts are verified
//   against the engine; see plan/help.md Part 1 for file-by-file references.
//
//   The Quick Guide / Intro Video tab links are PARKED for now (owner's
//   call): the guide renders directly, the video is unreachable until the
//   tabs return. showVideo() and TUTORIAL_BASE are kept so restoring is a
//   matter of re-adding the tab markup + listeners (see render below).
//   "?intro" deep-links here (handled in boot.js).
//
// COPY NOTES (engine-verified; keep these in sync if rules change):
//   - Keyword spelling matches CARD TEXT: "Ravager" (the data flag is the
//     legacy misspelling `ravenger`; players never see that).
//   - "Stunned" copy deliberately says only "not ready to attack" (owner's
//     call: keep it simple). The cut detail, for future editors: creatures
//     re-ready when their OWNER's turn ENDS (turn.js readies rows 0-1 after
//     the flip), so an enemy-applied stun lasts the victim's whole next turn.
//   - "Defeated" (0 health = slumped, healable, only digestion kills) was cut
//     per the owner; it's obvious in gameplay. Details in plan/help.md.
//   - Card-frame colors (card-tile-generator.js PixiTile branch order):
//     crop cost -> green (the two cropGain specials also cost crop), meat
//     cost -> red, waitCost/egg -> yellow (every egg card is otherwise
//     cost-free today), everything else -> the "free" frame (#7A7088 /
//     #BAAFC7 lavender tones; the guide calls it blue per the owner). The
//     Card Types labels are tinted to match (help.css .guide-type--*).
//   - Game Start facts: 5 Crop + a 5-card hand per player (duel-setup.js
//     dealDuel; Nibnab's bigger opener is his leader text's business).
//   - No em dashes anywhere in this file (owner's call).
// =============================================================================

import { GUIDE_HTML } from '../data/guide-content.js';

/** Legacy tutorial asset host (the parked intro video lives there). */
const TUTORIAL_BASE = 'https://deckbiter.netlify.app/tutorials/';

/** @type {HTMLElement|null} */
let screenEl = null;

/**
 * Render the guide.
 * @param {HTMLElement} container
 * @param {Record<string,string>} _params
 * @returns {void}
 */
export function render(container, _params) {
	screenEl = document.createElement('div');
	screenEl.className = 'screen';
	// The tab row is parked (see header). To restore it, put this back under
	// the title and re-wire the two listeners below:
	//   <div class="help-tabs">
	//     <button class="defaultButton" id="tab-guide">Quick Guide</button>
	//     <button class="defaultButton" id="tab-video">Intro Video</button>
	//   </div>
	screenEl.innerHTML = `
		<h1 class="screen-title">How To Play</h1>
		<div id="help-content"></div>`;
	container.appendChild(screenEl);

	// screenEl.querySelector('#tab-guide')?.addEventListener('click', showGuide);
	// screenEl.querySelector('#tab-video')?.addEventListener('click', showVideo);
	showGuide();
}

/** Nothing persistent to tear down. */
export function destroy() {
	screenEl = null;
}

/** The reference sheet (replaces the old three tutorial images). */
function showGuide() {
	const content = screenEl?.querySelector('#help-content');
	if (!content) return;
	content.innerHTML = GUIDE_HTML;
}

/** The intro video (old RenderIntro). Unreachable while the tabs are parked. */
function showVideo() {
	const content = screenEl?.querySelector('#help-content');
	if (!content) return;
	content.innerHTML = `
		<div class="help-video">
			<video controls preload="metadata">
				<source src="${TUTORIAL_BASE}Deckbiter_Intro2.mp4" type="video/mp4">
				Your browser does not support the video tag.
			</video>
		</div>`;
}
